import { Button, Card, DateRangePicker, Tab } from '@features/ui';
import { useMemo, useState } from 'react';
import { TTab } from '@src/types';
import {
  ECommerceDashboard,
  PayoutsDashboard,
} from '@features/admin/dashboard';
import { DateValueType } from '@lib/utils.ts';

const formatDateForBackend = (value: Date) => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const DashBoardAdminPage = () => {
  const [tabActive, setTabActive] = useState(0);
  const [valueStart, setValueStart] = useState<DateValueType>(null);
  const [valueEnd, setValueEnd] = useState<DateValueType>(null);

  const [appliedStartDate, setAppliedStartDate] = useState<string | null>(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 12);
    return formatDateForBackend(date);
  });
  const [appliedEndDate, setAppliedEndDate] = useState<string | null>(() =>
    formatDateForBackend(new Date())
  );

  const handleApply = () => {
    const startDate = valueStart?.startDate
      ? formatDateForBackend(new Date(valueStart.startDate))
      : null;
    const endDate = valueEnd?.startDate
      ? formatDateForBackend(new Date(valueEnd.startDate))
      : null;

    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
  };

  const tabs: TTab[] = useMemo(
    () => [
      {
        label: 'E-commerce Dashboard',
        component: (
          <ECommerceDashboard
            endDate={appliedEndDate}
            startDate={appliedStartDate}
          />
        ),
      },
      {
        label: 'Payouts Dashboard',
        component: (
          <PayoutsDashboard
            endDate={appliedEndDate}
            startDate={appliedStartDate}
          />
        ),
      },
    ],
    [appliedStartDate, appliedEndDate]
  );

  return (
    <div className={'min-w-[940px]'}>
      <Card className={'relative'}>
        <Tab
          className={'mb-5'}
          size={'2xl'}
          tabActive={tabActive}
          tabs={tabs}
          onChangeTab={setTabActive}
        />
        <div className={'absolute top-5 right-5 flex gap-6.5'}>
          <Button
            className="w-fit h-[38px]"
            size={'sm'}
            variant={'lime'}
            onClick={handleApply}
          >
            Apply
          </Button>
          <DateRangePicker
            asSingle={true}
            className={'min-w-[160px]'}
            placeholder={'From Date'}
            size={'sm'}
            value={valueStart}
            variant={'outline'}
            onChange={setValueStart}
          />
          <DateRangePicker
            asSingle={true}
            className={'min-w-[160px]'}
            placeholder={'To Date'}
            size={'sm'}
            value={valueEnd}
            variant={'outline'}
            onChange={setValueEnd}
          />
        </div>
      </Card>
    </div>
  );
};
